import createGetFormMeta from './selectors/getFormMeta';
import plain from './structure/plain';

export default createGetFormMeta(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/getFormMeta.js
// module id = 681
// module chunks = 7